<template>
  <div class="pc-modal-container">
    <template v-if="!hideHeader">
      <icu-icon
        v-if="showClose"
        class="close-icon pc-close"
        @click.native="$emit('close')"
      />
      <div
        :class="{'text-center': !showClose}"
        class="pc-modal__header"
      >
        <img src="@/assets/img/logo.svg" alt="logo" class="login-page__logo" />
      </div>
    </template>
    <slot></slot>
  </div>
</template>

<script>
import CloseIcon from '@/components/modals/CloseIcon.vue'
import IcuIcon from '@/components/common/IcuIcon'
export default {
  name: 'PcModalContainer',
  components: {IcuIcon, CloseIcon },
  props: {
    showClose: {
      type: Boolean,
      default: true
    },
    hideHeader: {
      type:Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/modals/PcModalContainer.scss";

</style>
